import { render, staticRenderFns } from "./AlterarSenhaInterno.vue?vue&type=template&id=036c7edb"
import script from "./AlterarSenhaInterno.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaInterno.vue?vue&type=script&lang=js"
import style0 from "./AlterarSenhaInterno.vue?vue&type=style&index=0&id=036c7edb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports